import StandardRestError from './Standard'

class InvitationExpiredError extends StandardRestError {
  static CODE = 'INVITATION_EXPIRED'

  constructor(message: string = 'Invitation expired', status = 409, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default InvitationExpiredError
